<div class='message-error' [ngClass]="_class">
  <small [ngStyle]="_alert ? {'color': 'rgba(0, 0, 0, 0.6)', 'font-size' : '10px'} : { }"
         [class.hide]='_hide'> {{_text}} </small>
</div>
